import { createSlice } from '@reduxjs/toolkit';

import { initialState } from '../redux';

export const otpSlice = createSlice({
  name: 'otpSlice',
  initialState,
  reducers: {
    validateLoginOtpRequest: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    validateLoginOtpSuccess: (state) => {
      state.isAuthenticated = true;
      state.isLoading = false;
    },
    validateLoginOtpFailure: (state) => {
      state.isLoading = false;
      state.error = true;
    },
  },
});
